import * as mutations from "../../mutation-types"

export const processTask = (store, item) => {
    if (item.files) {
        _.each(item.files, file => store.dispatch('processFile', file))
        delete(item.files)
    }

    if (item.notes) {
        _.each(item.notes, note => store.dispatch('processNote', note))
        delete(item.notes)
    }

    if (item.latest_note) {
        store.dispatch('processNote', item.latest_note)
        delete(item.latest_note)
    }

    if (item.last_editor) {
        store.dispatch('processUser', item.last_editor)
        delete (item.last_editor)
    }

    if (item.application) {
        store.dispatch(`${item.application_type}s/processItem`, item.application)
        delete(item.application)
    }

    if (item.subscribers) {
        _.each(item.subscribers, subscriber => store.dispatch('processSubscriber', subscriber))
        delete(item.subscribers)
    }

    if (item.project) {
        store.dispatch('processProject', item.project)

        _.each(item.project.contacts, contact => store.dispatch('processContact', contact))
        _.each(item.project.contacts, contact => store.dispatch('processProjectContact', {
            project_id: item.id, contact_id: contact.id
        }))

        delete(item.project)
    }

    if(item.project_service) {
        store.dispatch('processProjectService', item.project_service)
        delete(item.project_service)
    }

    if (item.subscribed_contacts) {
        _.each(item.subscribed_contacts, subscribedContact => store.dispatch('processSubscribedContact', subscribedContact))
        delete(item.subscribed_contacts)
    }

    store.commit(mutations.ADD_OR_UPDATE_TASK, item)
}

export const fetchTasks = (store, params) => {
    return axios.get(`/api/tasks`, { params })
        .then(res => {
            _.each(res.data.data, item => processTask(store, item))
            store.commit(mutations.SET_TASKS_TOTAL, res.data.total)
            return res
        })
}

export const fetchTaskById = (store, id) => {
    return axios.get(`/api/tasks/${id}`)
        .then(res => {
            processTask(store, res.data.data)
            return res
        })
}

export const createTask = (store, item) => {
    return axios.post(`/api/tasks`, item)
        .then(res => {
            processTask(store, res.data.data)

            if (item.status == 4) {
                store.dispatch('openGlobalTimelog', {
                    project_id: item.project_id,
                    activity_id: item.id,
                })
            }
            return res
        })
}

export const updateTask = (store, item) => {
    let currentItem = store.getters.taskById(item.id),
        openTimelogModal = currentItem.status != 4 && item.status == 4

    return axios.patch(`/api/tasks/${item.id}`, item)
        .then(res => {
            processTask(store, res.data.data)

            if (openTimelogModal) {
                store.dispatch('openGlobalTimelog', {
                    project_id: item.project_id,
                    activity_id: item.id,
                    closable: false,
                    isShort: true
                })
            }

            return res
        })
}

export const partialUpdateTask = (store, item) => {
    let currentItem = store.getters.taskById(item.id),
        openTimelogModal = currentItem.status != 4 && item.status == 4

    return axios.patch(`/api/tasks/${item.id}/partial`, item)
        .then(res => {
            processTask(store, res.data.data)

            if (openTimelogModal) {
                store.dispatch('openGlobalTimelog', {
                    project_id: currentItem.project_id,
                    activity_id: currentItem.id,
                    closable: false,
                    isShort: true
                })
            }

            return res
        })
}

export const removeTask = (store, item) => {
    return axios.delete(`/api/tasks/${item.id}`)
        .then(res => {
            store.commit(mutations.REMOVE_TASK, item)
            return res
        })
}

export const updateTasksApplication = (store, item) => {
    return axios.patch(`/api/tasks/${item.id}/updateapp`, item)
    .then(res => {
        _.forEach(res.data.data, p => processTask(store, p))
        return res
    })
}